export const isExternalLink = (url: string): boolean => /^http/i.test(url);
